import React, { useState, useEffect } from "react";
import "./home.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import CallForPapersSidebar from "../../CommonWidgets/CallForPapersSidebar/CallForPapersSidebar";
import CallForPapersSection from "../../CommonWidgets/CallForPapersSection/CallForPapersSection";
import InfoCardsSection from "../../CommonWidgets/InfoCardsSection/InfoCardsSection";
import Header from "../../Header/Header/Header";
import Footer from "../../Footer/MainFooter/Footer";
import { useLocation } from "react-router-dom";
import Indexing from "../../Indexing/Indexing"
export default function Home() {
  const slides = [
    {
      image: "/images/Banner/banner1.jpg",
      title: "Innovating Research for Tomorrow",
      content:
        "Explore cutting-edge research papers across communication and network applications.",
    },
    {
      image: "/images/Banner/banner2.jpg",
      title: "Empowering Knowledge Exchange",
      content:
        "A global platform connecting researchers, engineers, and scientists worldwide.",
    },
    {
      image: "/images/Banner/banner3.jpg",
      title: "Peer-Reviewed. Indexed. Trusted.",
      content:
        "Join the IJACNA community and publish your research with global visibility.",
    },
  ];
  const location = useLocation();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const section = document.getElementById(id);
      if (section) {
        const y = section.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: y, behavior: "smooth" });
        section.focus();
      }
    }
  }, [location]);

  // Auto slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <>
      <Header />
      <div className="ijacna-home">
        {/* 🔹 Image Slider Section */}
        <div className="ijacna-slider">
          <div
            className="ijacna-slider-inner"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {slides.map((slide, index) => (
              <div
                key={index}
                className="ijacna-slide"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="ijacna-slide-overlay">
                  <h2 className="ijacna-slide-title">{slide.title}</h2>
                  <p className="ijacna-slide-text">{slide.content}</p>
                </div>
              </div>
            ))}
          </div>

          {/* 🔹 Arrow Buttons */}
          <button className="ijacna-arrow left" onClick={prevSlide}>
            <FaChevronLeft />
          </button>
          <button className="ijacna-arrow right" onClick={nextSlide}>
            <FaChevronRight />
          </button>

          {/* 🔹 Navigation Dots */}
          <div className="ijacna-slider-dots">
            {slides.map((_, i) => (
              <span
                key={i}
                className={`ijacna-dot ${i === current ? "active" : ""}`}
                onClick={() => setCurrent(i)}
              ></span>
            ))}
          </div>
        </div>

        {/* 🔹 Welcome Section */}
        <section className="ijacna-home-content">
          <div className="ijacna-home-container">
            <div className="ijacna-home-header" id="ijacna-about-us">
              <h2 className="ijacna-home-heading">Welcome to IJACNA</h2>
              {/* <button className="ijacna-submit-btn">
                <span className="blink-text">Submit Research Paper ↗</span>
              </button> */}
            </div>

            <p className="ijacna-home-paragraph">
              <strong>
                International Journal of Advanced Communication and Network
                Applications (IJACNA){" "}
              </strong>
              is a globally recognized, peer-reviewed open-access journal
              dedicated to publishing high-quality research in communication,
              networking, and emerging information technologies. Our mission is
              to advance the understanding and innovation of network systems and
              communication technologies by providing a collaborative platform
              for researchers, scholars, and industry professionals.
            </p>
            <p className="ijacna-home-paragraph">
              We proudly present a platform dedicated to scholarly research and
              knowledge dissemination in the field of R&D. Our mission is to
              promote intellectual exchange, advance the frontiers of knowledge,
              and inspire innovation and critical thinking among researchers,
              academics, and professionals.
            </p>
            <p className="ijacna-home-paragraph">
              We strive to publish high-quality research articles that
              contribute to the growth and development of R&D. We welcome
              original research, empirical studies, theoretical frameworks,
              literature reviews, case studies, and methodological advancements
              that address key issues, challenges, and trends in the field.
            </p>
            <p className="ijacna-home-paragraph">
              Our scope encompasses a broad range of topics within Research &
              Development. From cutting-edge research to interdisciplinary
              approaches, we aim to understand the field and encourage
              interdisciplinary collaboration comprehensively. We also encourage
              submissions addressing emerging trends, innovative methodologies,
              and transformative technologies shaping the future of Research &
              Development.
            </p>
            <p className="ijacna-home-paragraph">
              In addition to research articles, our Journal offers
              thought-provoking reviews, conceptual papers, and critical
              commentaries that stimulate scholarly debates and contribute to
              the field's theoretical foundations. We also curate special issues
              dedicated to specific topics and invite experts to share their
              insights and perspectives on current challenges and emerging
              research areas.
            </p>
            <p className="ijacna-home-paragraph">
              Our dedicated editorial
              team ensures a thorough peer-review process to maintain the
              highest standards of quality and impact. We aim to provide an
              inclusive and supportive environment for researchers at all stages
              of their careers. We invite researchers, scholars, and
              practitioners worldwide to submit their work to our Journal
              and join us in advancing knowledge and making a meaningful
              impact in Research & Development. Together, let's explore new
              frontiers, inspire innovation, and shape the future of our dynamic
              field.
            </p>
          </div>

          <CallForPapersSidebar />
        </section>
        <Indexing />
        <InfoCardsSection />
        {/* <CallForPapersSection /> */}
      </div>
      <Footer />
    </>
  );
}
